<template>
  <g>
    <text
      :x="center"
      :y="center"
      :text-anchor="align"
      :transform="'translate(0 ' + transY + ')'"
      :style="{ fontSize: fontSize + 'px' }"
      :fill="textColor"
      class="percent-vect"
    >
      <tspan class="knockout-50">{{ num }}</tspan>

      <tspan
        class="knockout-30"
        :font-size="fontSize * 0.35"
        :dx="fontSize * -0.18"
        :dy="fontSize * -0.32"
        dominant-baseline="text-after-edge">
        %
      </tspan>

      <tspan
        class="adobe-clean-black fade-label text-uppercase"
        :font-size="isSmall ? '16px' : '20px'"
        :x="center"
        letter-spacing="0.1em"
        :dy="fontSize * 0.55 + ((fontSizeMax - fontSize) * 0.2)"
        :style="{ opacity: activated ? labelAlpha : 0 }"
        @transitionend="handleFade"
      >{{ label }}</tspan>
    </text>
  </g>
</template>

<script>
  import Percentage from '@/components/report/content/Percentage'

  export default {
    name: 'PercentVect',
    mixins: [ Percentage ],
    props: {
      fontSize: { type: Number, default () { return 96 } },
      fontSizeMax: { type: Number, default () { return 96 } },
      fixScale: { type: Boolean, default () { return false } },
      textColor: { type: String, default () { return '#FFFFFF' } },
      center: { type: Number, default () { return 100 } },
      activated: { type: Boolean, default () { return false } }
    },
    computed: {
      transY () { return !this.fixScale ? Math.min( 10, (this.num / 40) * 10 ) : 0 }
    },
    methods: {
      getIndWords () {
        this.indWords = []
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/global/the_goods";

  .fade-label {
    transition : opacity #{$data-trans-time / 6};
  }

  .percent-vect {
    transition : fill #{$data-trans-time / 4} ease-in-out;
  }
</style>



// WEBPACK FOOTER //
// src/components/svg/PercentVect.vue